import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActions = ({ selectedCount, onMarkAsRead, onDelete, onCancel }) => {
  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Icon name="CheckSquare" size={20} className="text-[#FF6A00]" />
        <span className="text-sm font-medium text-foreground">
          {selectedCount} notification{selectedCount > 1 ? 's' : ''} selected
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onMarkAsRead}
          iconName="Check"
          iconPosition="left"
        >
          Mark as read
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={onDelete}
          iconName="Trash2"
          iconPosition="left"
        >
          Delete
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onCancel}
          iconName="X"
          iconPosition="left"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default BulkActions;